import { IconChartBar } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { AuthBrandScene } from "@/components/auth/auth-brand-scene";

interface AuthPageLayoutProps {
  children: React.ReactNode;
}

export function AuthPageLayout({ children }: AuthPageLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 bg-white p-6 md:p-10">
        <div className="flex items-center justify-center gap-2 md:justify-start">
          <div className="flex items-center gap-2 font-medium">
            <div className="flex size-6 items-center justify-center rounded-md bg-ink text-surface">
              <IconChartBar className="size-4" />
            </div>
            {t("appName")}
          </div>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-sm">{children}</div>
        </div>
      </div>
      <AuthBrandScene />
    </div>
  );
}
